<!-- <div class="input-and-split vertical-divider margin-bottom padding-bottom background"> -->
<div>
    <nz-divider
        class="no-margin"
        nzPlain="true"
        [nzText]="text"
        nzOrientation="left"
    >
        <ng-template #text>
            <div class="sider-divider-text">{{ getColumnLabel() }}</div>
        </ng-template>
    </nz-divider>

    <div class="container">
        <nz-select
            [(ngModel)]="selectedOptionsViewModel"
            (nzOpenChange)="onOpenedChange($event)"
            (ngModelChange)="onSelectedViewOptionsModelChange($event)"
            [nzAllowClear]="true"
            nzAutoClearSearchValue="true"
            [nzBorderless]="false"
            [nzDropdownMatchSelectWidth]="false"
            [nzDropdownStyle]="{ 'font-size': '12px' }"
            [nzLoading]="_dataLoaderData.isLoading"
            [nzMaxTagCount]="0"
            [nzMaxTagPlaceholder]="tagPlaceHolder"
            [nzMode]="nzMode"
            [nzOptionOverflowSize]="19"
            [nzOptionHeightPx]="25"
            [nzPlaceHolder]="getColumnLabel()"
            [nzShowArrow]="true"
            nzSize="small"
        >
            <nz-option
                *ngFor="let item of availableViewOptions"
                [nzLabel]="item.label"
                [nzValue]="item.value"
            ></nz-option>
        </nz-select>
        <ng-template #tagPlaceHolder let-selectedList>{{
            selectedValuesPill()
        }}</ng-template>

        <div class="quick-selection-buttons" *ngIf="showQuickSelectionButtons">
            <button
                nz-button
                nzType="default"
                (click)="previousSelectionOption()"
                [disabled]="prevDisabled"
                nzSize="small"
            >
                &lt;
            </button>

            <button
                nz-button
                nzType="default"
                (click)="nextSelectionOption()"
                [disabled]="nextDisabled"
                nzSize="small"
            >
                &gt;
            </button>
        </div>

        <div class="excl-split-checkboxes">
            <label
                *ngIf="excludeMode"
                nz-checkbox
                [(ngModel)]="excludeChecked"
                (ngModelChange)="onFilterTypeCheckboxModelChange($event)"
                >Excl</label
            >

            <label
                *ngIf="splitable"
                nz-checkbox
                [(ngModel)]="splitChecked"
                (ngModelChange)="onSplitChange($event)"
                style="margin-left: 0px"
                >Split</label
            >
        </div>
    </div>
</div>
